import { ItemDocumentFinderThemeSizeConfig } from './types';

const small: ItemDocumentFinderThemeSizeConfig = {
  itemDocumentFinder: {},
};

export default small;
